import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { LayoutSplashScreen } from './LayoutContext'
import * as builder from '../ducks/builder'

/**
 * Used to synchronize current layout `menuConfig`, `layoutConfig` and
 * `htmlClassService` with redux store.
 */
export default function LayoutInitializer({ children, layoutConfig, htmlClassService }) {
  const dispatch = useDispatch()
  const builderState = useSelector(({ builder }) => builder)
  const [adminMenuState, setAdminMenuState] = React.useState(false)

  useEffect(() => {
    const existeUsuario = !!window.localStorage.getItem('token')

    if (existeUsuario) {
      setAdminMenuState(true)
    }
  }, [dispatch])

  useEffect(() => {
    if (layoutConfig.demo !== builderState.layoutConfig.demo) {
      dispatch(builder.actions.setLayoutConfigs(layoutConfig))
    }
  }, [dispatch, builderState, layoutConfig])

  useEffect(() => {
    dispatch(builder.actions.setHtmlClassService(htmlClassService))
  }, [dispatch, htmlClassService])

  return htmlClassService === builderState.htmlClassServiceObjects && adminMenuState ? (
    // Render content when `htmlClassService` synchronized with redux store.
    <>{children}</>
  ) : (
    // Otherwise sow loading splash screen.
    <LayoutSplashScreen />
  )
}
